const KEYS = ['section', 'status', 'leadStatus', 'packStatus', 'packVideo', 'packApplication', 'geoCountry', 'cpmBand', 'page', 'application', 'month', 'record', 'startDate', 'endDate', 'source', 'team', 'manager'];
const UUID = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';

export function monitoringParams(search) {
  const source = new URLSearchParams(search); const result = new URLSearchParams();
  for (const key of KEYS) if (source.get(key)) result.set(key, source.get(key));
  return result;
}

export function reportRoute(path) {
  const match = path.match(new RegExp(`^/monitoring2/reports/(native|legacy|import)/(${UUID})/?$`, 'i'));
  return match ? { kind: match[1], id: match[2] } : null;
}

export function monitoringReturnPath(path, search) {
  const safe = path === '/monitoring2' || path === '/monitoring2/reports' || reportRoute(path) ? path : '/monitoring2';
  const query = monitoringParams(search).toString();
  return safe + (query ? `?${query}` : '');
}

export function canSaveReviewed({ review, destination, requestKey, busy, error, now = Date.now() }) {
  return Boolean(review?.reviewToken && review.destination === destination && review.requestKey === requestKey
    && Date.parse(review.expiresAt) > now && !busy && !error);
}

export function formatSourceCell(cell) {
  if (cell.state === 'absent' || cell.state === 'blank') return '';
  const raw = String(cell.value ?? cell.rawValue ?? '');
  if (cell.xmlType !== 'n' || raw === '' || !Number.isFinite(Number(raw))) return raw;
  const formats = {
    '#,##0': { useGrouping: true, minimumFractionDigits: 0, maximumFractionDigits: 0 },
    '#,##0.00': { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 },
    '0.00': { useGrouping: false, minimumFractionDigits: 2, maximumFractionDigits: 2 },
    '0.00%': { style: 'percent', minimumFractionDigits: 2, maximumFractionDigits: 2 },
    '[$$]#,##0.00': { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 },
  };
  const options = Object.hasOwn(formats, cell.numberFormat) ? formats[cell.numberFormat] : null;
  if (!options) return raw;
  return (cell.numberFormat === '[$$]#,##0.00' ? '$' : '') + new Intl.NumberFormat('ru-RU', options).format(Number(raw));
}

export function reportError(error) {
  const code = error?.data?.error ?? error?.message;
  return ({ team_inputs_unavailable: 'Данные команды для расчёта временно недоступны.',
    review_stale: 'Данные изменились — проверьте отчёт заново.',
    report_team_closed: 'Отчёт команды за этот месяц уже закрыт; он в «Отчётах».',
    report_already_saved: 'Отчёт уже сохранён. Откройте его в разделе «Отчёты».', report_not_ready: 'Недостаточно данных за выбранные даты.',
    report_inputs_unavailable: 'Данные для расчёта временно недоступны.',
    invalid_report_window: 'Проверьте даты: старт не позже конца.', report_window_unavailable: 'За выбранные дни ещё нет готового ежедневного скана.',
    report_window_month_mismatch: 'Конец отчёта должен остаться в месяце сохранённого отчёта.', report_not_found: 'Отчёт не найден или недоступен.',
    report_forbidden: 'Недостаточно прав для этого действия.', report_conflict: 'Отчёт уже изменён. Обновите страницу.',
    pack_already_claimed: 'Пачка уже учтена в другом сохранённом отчёте за этот месяц.' })[code] ?? 'Не удалось выполнить действие. Повторите попытку.';
}

/** Splits the live team tables into the viewer's own row and whether others' rows are shown beneath it (read-only). */
export function splitOwnReport(teams, userId) {
  const list = teams ?? [];
  const team = userId ? list.find((t) => t.rows.some((r) => r.managerId === userId)) ?? null : null;
  const row = team ? team.rows.find((r) => r.managerId === userId) : null;
  const showTeams = list.some((t) => t.rows.some((r) => r.managerId !== userId));
  return { team, row, showTeams, split: Boolean(row && showTeams) };
}
